import { render, staticRenderFns } from "./ExportDelivery.vue?vue&type=template&id=fdf360c6&"
import script from "./ExportDelivery.vue?vue&type=script&lang=js&"
export * from "./ExportDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports